function CaravanStructureRequestTransformer(
	jsonMapper,
	util,
	quoteOptions,
	storage
) {
	var structureQuoteMapping = {
		periodStartDate: '=_input.caravanForm.getStarted.policyStartDate',
		caravans: [],

		'caravans.0': '=_input.caravanForm.caravanDetails',

		'caravans.0.caravanType':
			'=_input.caravanForm.aboutYourCaravan.vehicleType',
		'caravans.0.caravanInfo': '=_regoSearch',
		'caravans.0.garageAddress': '=_addressSearch',

		// caravanDetails
		'caravans.0.registrationNumber':
			'=_input.caravanForm.caravanDetails.regoNumber',
		'caravans.0.locationType':
			'=_input.caravanForm.caravanDetails.locationDescription',
		'caravans.0.securityType':
			'=_input.caravanForm.caravanDetails.security',
		'caravans.0.caravanUsageType':
			'=_input.caravanForm.caravanDetails.primaryUse',
		'caravans.0.existingDamageType':
			'=_input.caravanForm.caravanDetails.existingDamage',
		'caravans.0.purchaseMonthYear':
			'=_input.caravanForm.caravanDetails.whenDidYouBuyYear',
		'caravans.0.purchaseMonthYear':
			'=_input.caravanForm.caravanDetails.whenDidYouBuyMonth',
		'caravans.0.isCaravanRegistered':
			'=_input.caravanForm.caravanDetails.isCaravanRegistered',
		'caravans.0.isPermResidence':
			'=_input.caravanForm.caravanDetails.isPremanentResidence',
		'caravans.0.isCaravanOnNonRetractableJacks':
			'=_input.caravanForm.caravanDetails.nonRetractableJacksorPermanantFoundations',
		'caravans.0.isCaravanConnectedToPlumbing':
			'=_input.caravanForm.caravanDetails.permanentlyConnected',
		'caravans.0.chassisNumber':
			'=_input.caravanForm.caravanDetails.chassisNumber',

		'caravans.0.replacementCostValue':
			'=_input.caravanForm.sumInsured.annexeReplacementCost',
		'caravans.0.agreedAmountValue':
			'=_input.caravanForm.sumInsured.agreedValue',

		// aboutYourContents
		'caravans.0.agreedAmountValue':
			'=_input.caravanForm.aboutYourContents.agreedValue',
		'caravans.0.replacementCostValue':
			'=_input.caravanForm.aboutYourContents.annexeReplacementCost',
		'caravans.0.contentsCoverAmount':
			'=_input.caravanForm.aboutYourContents.generalContentsValue',

		'caravans.0.contentsCover':
			'=_input.caravanForm.aboutYourContents.insureContents',
		'caravans.0.excess.voluntaryVehicleExcess':
			'=_input.caravanForm.excess.voluntaryVehicleExcess',

		'caravans.0.yearsContinuousInsurance':
			'=_input.caravanForm.driver.yearsContinuousInsurance',
		'caravans.0.timeSinceLastClaim':
			'=_input.caravanForm.driver.timeSinceLastClaim',

		policyHolders: [],
		'policyHolders.0': {},
		'policyHolders.0.mainHolder':
			'=_input.caravanForm.mainPolicyHolder.mainPolicyHolder',
		'policyHolders.0.contact': '=_input.caravanForm.mainPolicyHolder',
		'policyHolders.0.contact.primaryAddress': '=_addressSearch',

		policyAddress: '=_addressSearch',
		email: '=_input.email',
		campaignCode: '=_input.caravanForm.promotionalCode.promotionalCode',
		postalAddress: '=_addressSearch-postal-address'
	};

	function updateCaravanInfo(transformedRequest, userInput) {
		var aboutYourCaravan = userInput.caravanForm.aboutYourCaravan,
			searchType = userInput.caravanForm.aboutYourCaravan.searchType,
			caravanInfo = transformedRequest.caravans[0].caravanInfo || {};

		if (aboutYourCaravan) {
			if (searchType === 'manually') {
				caravanInfo = {
					modelYear: aboutYourCaravan.year,
					make: aboutYourCaravan.make,
					model: aboutYourCaravan.model,
					bodyType: aboutYourCaravan.bodyType,
					berths: aboutYourCaravan.berths,
					weight: aboutYourCaravan.weight,
					caravanLength: aboutYourCaravan.manualLength,
					lengthUnits: aboutYourCaravan.manualLengthUnits,
					customBuilt: aboutYourCaravan.customBuilt,
					numberOfAxles: aboutYourCaravan.numOfAxels
				};

				transformedRequest.caravans[0].caravanInfo = caravanInfo;
			} else if (searchType === 'yearMakeModel') {
				if (caravanInfo && caravanInfo.vgiId) {
					//if aviailable continue
				} else {
					//set vgiId from retrive
					caravanInfo = {
						vgiId: aboutYourCaravan.vgiId
					};
					transformedRequest.caravans[0].caravanInfo = caravanInfo;
				}
			}
		}

		return transformedRequest;
	}

	function updateContentsItems(transformedRequest, userInput) {
		var aboutYourContents = userInput.caravanForm.aboutYourContents;

		if (
			aboutYourContents &&
			aboutYourContents.contentsItems &&
			aboutYourContents.contentsItems.length > 0
		) {
			var contents = aboutYourContents.contentsItems;

			var specifiedItems = contents.map(function(item, i) {
				return {
					category: item.category.value,
					description: item.description,
					value: item.value
				};
			});

			transformedRequest.caravans[0].specifiedContents = true;
			transformedRequest.caravans[0].specifiedItems = specifiedItems;
		}

		return transformedRequest;
	}

	function updateTotalSpecifiedContentsValue(transformedRequest, userInput) {
		var aboutYourContents = userInput.caravanForm.aboutYourContents;

		if (
			aboutYourContents &&
			aboutYourContents.contentsItems &&
			aboutYourContents.contentsItems.length > 0
		) {
			var contents = aboutYourContents.contentsItems,
				totalSpecifiedItemsValue = 0;

			for (var index in contents) {
				totalSpecifiedItemsValue += contents[index].value;
			}

			transformedRequest.caravans[0].totalSpecifiedItemsValue = totalSpecifiedItemsValue;
		}

		return transformedRequest;
	}

	function updateTotalContentsSpecifiedValue(transformedRequest, userInput) {
		var aboutYourContents = userInput.caravanForm.aboutYourContents;

		if (aboutYourContents && aboutYourContents.generalContentsValue) {
			var contentsCoverAmount =
					userInput.caravanForm.aboutYourContents
						.generalContentsValue,
				totalSpecifiedItemsValue =
					transformedRequest.caravans[0].totalSpecifiedItemsValue ||
					0;

			if (contentsCoverAmount && totalSpecifiedItemsValue) {
				transformedRequest.caravans[0].totalContentsAndSpecifiedValue =
					contentsCoverAmount + totalSpecifiedItemsValue;
			}
		}

		if (transformedRequest.caravans[0].contentsCover === false) {
			transformedRequest.caravans[0].contentsCoverAmount = '';
		}

		if (aboutYourContents.insureContents === undefined) {
			transformedRequest.caravans[0].contentsCover = false;
		}

		return transformedRequest;
	}

	function updateVehicleDetails(transformedRequest, userInput) {
		transformedRequest.caravans[0] = util.deepClone(
			transformedRequest.caravans[0]
		);

		if (userInput.caravanForm.insuredExcessValue) {
			transformedRequest.caravans[0].sumInsuredType =
				userInput.caravanForm.insuredExcessValue.comprehensivePref;
		}
		//userInput.caravanForm.insuredExcessValue
		if (userInput.caravanForm.caravanDetails) {
			if (userInput.caravanForm.caravanDetails.whenDidYouBuyYear) {
				transformedRequest.caravans[0].purchaseMonthYear =
					userInput.caravanForm.caravanDetails.whenDidYouBuyYear +
					'-' +
					userInput.caravanForm.caravanDetails.whenDidYouBuyMonth;
			}

			transformedRequest.caravans[0].businessUsageType =
				userInput.caravanForm.caravanDetails.businessActivityType ||
				userInput.caravanForm.caravanDetails.commercialActivityType ||
				undefined;
		}

		return transformedRequest;
	}

	function updatePolicyHolders(transformedRequest, userInput) {
		var caravanForm = userInput.caravanForm,
			mainPolicyHolder = caravanForm.mainPolicyHolder,
			drivers = transformedRequest.caravans[0].drivers;

		if (mainPolicyHolder) {
			var policyHolders = [];

			mainPolicyHolder.policyContact =
				caravanForm.mainPolicyHolderContact;

			if (mainPolicyHolder.isMainDriverMainPolicyHolder) {
				var driver = util.deepClone(
					transformedRequest.caravans[0].drivers[0].driver
				);
				Object.extend(mainPolicyHolder, driver.person);
			}

			policyHolders.push(mainPolicyHolder);

			if (
				caravanForm.additionalPolicyHolders &&
				caravanForm.additionalPolicyHolders.policyHolders
			) {
				policyHolders = policyHolders.concat(
					caravanForm.additionalPolicyHolders.policyHolders
				);
			}

			policyHolders.forEach(function(policyHolder, index) {
				var contact = util.deepClone(policyHolder);
				if (!transformedRequest.policyHolders[index])
					transformedRequest.policyHolders[index] = {};

				var transformedContact =
					transformedRequest.policyHolders[index];
				if (!contact.contactType)
					contact.contactType =
						'person'; /* TODO : check to make sure this condition is always safe to use */

				contact.prefix = contact.title;
				contact.hasClaim = contact.fourYears_vehicleAccidentsClaims;
				contact.hasInfringement =
					contact.fourYears_chargedOrConvictedOffences;
				contact.hasLostLicence = contact.fourYears_licenceRSDC;
				contact.hasConviction =
					contact.tenYears_chargedOrConvictedOffences;

				if (contact.policyContact) {
					Object.extend(contact, contact.policyContact);
					if (contact.primaryPhone == 'mobile')
						contact.cellPhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'home')
						contact.homePhone = contact.primaryPhoneNumber;
					else if (contact.primaryPhone == 'work')
						contact.workPhone = contact.primaryPhoneNumber;

					delete contact.policyContact;
				}

				if (!contact.primaryAddress)
					contact.primaryAddress = util.clone(
						mainPolicyHolder.primaryAddress
					);

				contact.hasClaim = contact.fourYears_vehicleAccidentsClaims;
				contact.hasInfringement =
					contact.fourYears_chargedOrConvictedOffences;
				contact.hasLostLicence = contact.fourYears_licenceRSDC;
				contact.hasConviction =
					contact.tenYears_chargedOrConvictedOffences;
				contact.zeroDemerits = contact.NSWDemeritPoints;

				contact.drivingHistory = [];

				// 4 years Charged or Convicted Offences
				if (
					contact.fourYears_chargedOrConvictedOffences &&
					contact.fourYears_chargedOrConvictedOffencesDetails.length <
						1
				) {
					contact.fourYears_chargedOrConvictedOffences = false;
				}

				if (contact.fourYears_chargedOrConvictedOffences) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.fourYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				// 4 years Licence RSDC
				if (
					contact.fourYears_licenceRSDC &&
					contact.fourYears_licenceRSDCDetails.length < 1
				) {
					contact.fourYears_licenceRSDC = false;
				}

				if (contact.fourYears_licenceRSDC) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.fourYears_licenceRSDCDetails.slice()
					);
				}

				// 4 years accidents and claims
				if (
					contact.fourYears_vehicleAccidentsClaims &&
					contact.fourYears_vehicleAccidentsClaimsDetails.length < 1
				) {
					contact.fourYears_vehicleAccidentsClaims = false;
				}

				if (contact.fourYears_vehicleAccidentsClaims) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.fourYears_vehicleAccidentsClaimsDetails.slice()
					);
				}

				// 10 years charged or convicted
				if (
					contact.tenYears_chargedOrConvictedOffences &&
					contact.tenYears_chargedOrConvictedOffencesDetails.length <
						1
				) {
					contact.tenYears_chargedOrConvictedOffences = false;
				}

				if (contact.tenYears_chargedOrConvictedOffences) {
					contact.drivingHistory = contact.drivingHistory.concat(
						contact.tenYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				// Concat time!
				contact.drivingHistory.forEach(function(dh) {
					dh.pattern = {
						publicID: '',
						description: '',
						code: '',
						filter1: ''
					};
					if (dh.description) {
					} else {
						if (dh.accident) {
							dh.description = dh.accident;
						} else if (dh.incident) {
							dh.description = dh.incident;
						}
					}
					dh.pattern.publicID = dh.description.publicID;
					dh.pattern.description = dh.description.label;
					dh.pattern.code = dh.description.code;
					dh.pattern.filter1 = dh.description.filter1;

					dh.month = transposeMonth(dh.month.value);
					dh.year = dh.year.value;

					delete dh.description;
				});

				if (!transformedContact.contact)
					transformedContact.contact = {};

				Object.extend(transformedContact.contact, contact);
			});
		} else if (
			transformedRequest.caravans[0].drivers[0] &&
			transformedRequest.caravans[0].drivers[0].driver &&
			transformedRequest.caravans[0].drivers[0].driver.person
		) {
			var driver = transformedRequest.caravans[0].drivers[0].driver;
			var contact = transformedRequest.policyHolders[0].contact;

			Object.extend(contact, driver.person);
			contact.contactType =
				'person'; /* TODO : check to make sure this condition is always safe to use */
			contact.hasClaim = driver.hasClaim;
			contact.hasConviction = driver.hasConviction;
		}

		transformedRequest.policyHolders[0].mainHolder = true;

		if (userInput.email) {
			/** required for saving/retrieving the policy */
			if (
				userInput.caravanForm.tellUsABitMore &&
				userInput.caravanForm.tellUsABitMore.yourEmailAddress
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.caravanForm.tellUsABitMore.yourEmailAddress;
			} else if (
				userInput.caravanForm.mainPolicyHolderContact &&
				userInput.caravanForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.caravanForm.mainPolicyHolderContact.emailAddress1;
			} else {
				transformedRequest.policyHolders[0].contact.emailAddress1 =
					userInput.email;
			}

			if (
				angular.isDefined(
					transformedRequest.caravans[0].drivers[0].driver
				)
			) {
				if (
					userInput.caravanForm.tellUsABitMore &&
					userInput.caravanForm.tellUsABitMore.yourEmailAddress
				) {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.caravanForm.tellUsABitMore.yourEmailAddress;
				} else if (
					userInput.caravanForm.mainPolicyHolderContact &&
					userInput.caravanForm.mainPolicyHolderContact.emailAddress1
				) {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.caravanForm.mainPolicyHolderContact.emailAddress1;
				} else {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.email;
				}
			}
		} else {
			if (
				userInput.caravanForm.tellUsABitMore &&
				userInput.caravanForm.tellUsABitMore.yourEmailAddress
			) {
				if (transformedRequest.policyHolders[0].contact.emailAddress1) {
					//use the existing if available
				} else {
					transformedRequest.policyHolders[0].contact.emailAddress1 =
						userInput.caravanForm.tellUsABitMore.yourEmailAddress;
				}

				if (
					transformedRequest.caravans[0].drivers[0].driver.person
						.emailAddress1
				) {
					//use the existing if available
				} else {
					transformedRequest.caravans[0].drivers[0].driver.person.emailAddress1 =
						userInput.caravanForm.tellUsABitMore.yourEmailAddress;
				}
			}
		}

		if (
			userInput.caravanForm &&
			userInput.caravanForm.mainPolicyHolderContact &&
			userInput.caravanForm.mainPolicyHolderContact
				.personalContactDetailsMailingPreference
		) {
			transformedRequest.documentDeliveryMethod =
				userInput.caravanForm.mainPolicyHolderContact.personalContactDetailsMailingPreference;
			delete transformedRequest.policyHolders[0].contact
				.personalContactDetailsMailingPreference;
		}

		return transformedRequest;
	}

	function updateDrivers(transformedRequest, userInput) {
		transformedRequest.caravans[0].drivers = [];
		if (
			userInput.caravanForm.driver &&
			userInput.caravanForm.driver.drivers
		) {
			userInput.caravanForm.driver.drivers.forEach(function(driver) {
				driver.person.contactType = 'person';
				driver.person.prefix = driver.person.title;
				driver.person.primaryAddress = transformedRequest.policyAddress;
				driver.person.primaryAddress.addressType = 'residential';

				driver.hasClaim = driver.person.hasClaim =
					driver.fourYears_vehicleAccidentsClaims;
				driver.hasInfringement =
					driver.fourYears_chargedOrConvictedOffences;
				driver.hasLostLicence = driver.fourYears_licenceRSDC;
				driver.hasConviction = driver.person.hasConviction =
					driver.tenYears_chargedOrConvictedOffences;
				driver.zeroDemerits = driver.NSWDemeritPoints;
				//driver.yearsLicenced = driver.yearsHeld ;

				switch (driver.yearsHeld) {
					case 'lessThan_1':
						driver.yearsLicenced = '7';
						break;
					case 'greaterThan_5':
						driver.yearsLicenced = '6';
						break;
					default:
						driver.yearsLicenced = driver.yearsHeld;
				}

				if (
					driver.fourYears_chargedOrConvictedOffences &&
					(!driver.fourYears_chargedOrConvictedOffencesDetails ||
						driver.fourYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_vehicleAccidentsClaims &&
					(!driver.fourYears_vehicleAccidentsClaimsDetails ||
						driver.fourYears_vehicleAccidentsClaimsDetails.length <
							1)
				) {
					driver.fourYears_chargedOrConvictedOffences = false;
				}

				if (
					driver.fourYears_licenceRSDC &&
					(!driver.fourYears_licenceRSDCDetails.length ||
						driver.fourYears_licenceRSDCDetails.length < 1)
				) {
					driver.fourYears_licenceRSDC = false;
				}

				if (
					driver.tenYears_chargedOrConvictedOffences &&
					(!driver.tenYears_chargedOrConvictedOffencesDetails ||
						driver.tenYears_chargedOrConvictedOffencesDetails
							.length < 1)
				) {
					driver.tenYears_chargedOrConvictedOffences = false;
				}

				driver.driverHistory = [];

				if (driver.fourYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				if (driver.fourYears_vehicleAccidentsClaims) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_vehicleAccidentsClaimsDetails.slice()
					);
				}

				if (driver.fourYears_licenceRSDC) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.fourYears_licenceRSDCDetails.slice()
					);
				}

				if (driver.tenYears_chargedOrConvictedOffences) {
					driver.driverHistory = driver.driverHistory.concat(
						driver.tenYears_chargedOrConvictedOffencesDetails.slice()
					);
				}

				driver.driverHistory.forEach(function(dh) {
					dh.pattern = {
						publicID: '',
						description: '',
						code: '',
						filter1: ''
					};
					dh.pattern.publicID = dh.description.publicID;
					dh.pattern.description = dh.description.label;
					dh.pattern.code = dh.description.code;
					dh.pattern.filter1 = dh.description.filter1;

					dh.month = transposeMonth(dh.month.value);
					dh.year = dh.year.value;

					delete dh.description;
				});

				var driverObj = {
					driver: driver
				};

				// var toDelete = isItemMarkedForDelete('driver', driver) ;
				// if (toDelete) driverObj.markedForDelete = true ;

				transformedRequest.caravans[0].drivers.push(driverObj);
			});

			transformedRequest.caravans[0].drivers[0].driverUsage = 'main';
		} else {
			transformedRequest.caravans[0].drivers = [
				{
					driverUsage: 'main'
				}
			];
		}

		return transformedRequest;
	}

	function updateVehicleSubType(transformedRequest, userInput) {
		var caravanDetails = userInput.caravanForm.caravanDetails,
			caravanType = userInput.caravanForm.aboutYourCaravan.vehicleType,
			vehicleSubType = null;

		if (caravanDetails && caravanDetails.vehicleSubType) {
			vehicleSubType = caravanDetails.vehicleSubType;
		} else {
			switch (caravanType) {
				case 'caravan':
					vehicleSubType = 'standardcaravan';
					break;
				case 'campertrailer':
					vehicleSubType = 'standardcampertrailer';
					break;
				case 'goodscarryingtrailer':
					vehicleSubType = 'boxtrailer';
					break;
			}
		}

		transformedRequest.caravans[0].caravanSubType = vehicleSubType;

		return transformedRequest;
	}

	function updateTotalCaravanValue(transformedRequest, userInput) {
		var sumInsured = userInput.caravanForm.sumInsured;

		if (
			sumInsured &&
			sumInsured.annexeReplacementCost &&
			sumInsured.agreedValue
		) {
			transformedRequest.caravans[0].totalCaravanValue =
				sumInsured.agreedValue + sumInsured.annexeReplacementCost;
		}

		return transformedRequest;
	}

	function updateVehicleInsuranceTypeAndAmount(
		transformedRequest,
		userInput
	) {
		var insuredExcessValue = userInput.caravanForm.insuredExcessValue;

		if (insuredExcessValue) {
			transformedRequest.caravans[0].sumInsuredType =
				insuredExcessValue.comprehensivePref;
			if (insuredExcessValue.comprehensivePref == 'agreed') {
				transformedRequest.caravans[0].sumInsuredAmount =
					insuredExcessValue.agreedValue;
			} else if (quoteOptions.getSelectedQuoteResult()) {
				transformedRequest.caravans[0].sumInsuredAmount = quoteOptions
					.getSelectedQuoteResult()
					.getAnnual().vehicleValue.lower;
			}
		}
		return transformedRequest;
	}

	function updateDiscountLayup(transformedRequest, userInput) {
		var discountOptions = userInput.caravanForm.discountOptions;

		if (discountOptions && discountOptions.discountLayup) {
			var coverageOptions =
					transformedRequest.caravans[0].coverageOptions || [],
				discountLayup = {
					name: 'QPCLayupCover',
					selected: discountOptions.discountLayup,
					required: false
				};

			if (
				!!discountOptions.discountLayup &&
				!!discountOptions.discountLayupMonths
			) {
				discountLayup.activeLayupMonths = [];

				var layupMonths = Object.keys(
					discountOptions.discountLayupMonths
				);
				layupMonths.forEach(function(monthItem) {
					if (discountOptions.discountLayupMonths[monthItem]) {
						discountLayup.activeLayupMonths.push(monthItem);
					}
				});
			}

			coverageOptions.push(discountLayup);

			transformedRequest.caravans[0].coverageOptions = coverageOptions;
		}

		return transformedRequest;
	}

	function updateVehicleInsuranceOptionalBenefits(
		transformedRequest,
		userInput
	) {
		var optionalBenefits = userInput.caravanForm.optionalBenefits;

		if (optionalBenefits) {
			var coverageOptions =
				transformedRequest.caravans[0].coverageOptions || [];

			for (var key in optionalBenefits) {
				//dd-6512-Do not include "expiryDate" option
				if (key.indexOf('QPC') > -1) {
					coverageOptions.push({
						name: key,
						selected: optionalBenefits[key],
						required: false
					});
				}
			}
			transformedRequest.caravans[0].coverageOptions = coverageOptions;
		}
		return transformedRequest;
	}

	function updateOnSiteDiscount(transformedRequest, userInput) {
		var discountOptions = userInput.caravanForm.discountOptions;

		if (discountOptions) {
			var coverageOptions =
					transformedRequest.caravans[0].coverageOptions || [],
				onSiteDiscount = discountOptions.onSiteDiscount;

			if (onSiteDiscount === true) {
				coverageOptions.push({
					name: 'QPCOnSite',
					selected: true,
					required: true
				});

				// coverageOptions.push({
				// 	name:'QPCLayupCover',
				// 	selected:false
				// });
			}

			if (onSiteDiscount === false) {
				coverageOptions.push({
					name: 'QPCOnSite',
					selected: false,
					required: true
				});

				// coverageOptions.push({
				// 	name:'QPCLayupCover',
				// 	selected:false
				// });
			}

			transformedRequest.caravans[0].coverageOptions = coverageOptions;
		}

		return transformedRequest;
	}

	function updateFinanceType(transformedRequest, userInput) {
		var caravanDetails = userInput.caravanForm.caravanDetails,
			finance = caravanDetails ? caravanDetails.finance : 'none';

		if (caravanDetails) {
			if (caravanDetails.financeWith) {
				financeWith = caravanDetails.financeWith;
			} else {
				financeWith = null;
			}
		} else {
			financeWith = null;
		}

		if (finance) {
			transformedRequest.caravans[0].financeType = finance;

			if (
				financeWith &&
				financeWith.hasOwnProperty('label') &&
				financeWith.hasOwnProperty('value')
			) {
				transformedRequest.caravans[0].financeCompany = {};

				transformedRequest.caravans[0].financeCompany.name =
					financeWith.label;
				transformedRequest.caravans[0].financeCompany.publicID =
					financeWith.value;
			}
		}

		return transformedRequest;
	}

	// function isItemMarkedForDelete(typeName, item) {
	// 	var toRemove = aggregatedRemoveService.getList();
	// 	var itemsToRemove = toRemove[typeName] || [];
	// 	var removeItem = false ;
	// 	itemsToRemove.some(function(itemToRemove) {
	// 		if ( itemToRemove._aggregator.id == item._aggregator.id){
	// 			removeItem = true;
	// 			return;
	// 		}
	// 	});
	// 	return removeItem;
	// }

	function updateAgreedValue(transformedRequest, userInput) {
		var sumInsured = userInput.caravanForm.sumInsured;

		if (sumInsured && sumInsured.agreedValue) {
			transformedRequest.caravans[0].agreedAmountValue =
				sumInsured.agreedValue;
		}

		return transformedRequest;
	}

	function updateAnnexeValue(transformedRequest, userInput) {
		var sumInsured = userInput.caravanForm.sumInsured;

		if (sumInsured && sumInsured.annexeReplacementCost) {
			transformedRequest.caravans[0].replacementCostValue =
				sumInsured.annexeReplacementCost;
		}

		return transformedRequest;
	}

	function updatePurchasePrice(transformedRequest, userInput) {
		var caravanDetails = userInput.caravanForm.caravanDetails,
			aboutYourContents = userInput.caravanForm.aboutYourContents,
			purchasePrice = 100;

		if (caravanDetails && caravanDetails.purchasePrice) {
			purchasePrice = caravanDetails.purchasePrice;
		} else if (aboutYourContents && aboutYourContents.agreedValue) {
			// Use the agreed value if they're coming from rapid estimate
			purchasePrice = aboutYourContents.agreedValue;
		}

		transformedRequest.caravans[0].purchasePrice = purchasePrice;

		return transformedRequest;
	}

	//updates the email
	function updateEmail(transformedRequest, userInput) {
		if (
			userInput.caravanForm &&
			userInput.caravanForm.tellUsABitMore &&
			userInput.caravanForm.tellUsABitMore.yourEmailAddress
		) {
			transformedRequest.email =
				userInput.caravanForm.tellUsABitMore.yourEmailAddress;
		} else {
			//set email from maincontact if not available in tellUsABitMore
			if (
				userInput.caravanForm &&
				userInput.caravanForm.mainPolicyHolderContact &&
				userInput.caravanForm.mainPolicyHolderContact.emailAddress1
			) {
				transformedRequest.email =
					userInput.caravanForm.mainPolicyHolderContact.emailAddress1;
			}
		}

		// send the campaign code to GW
		if (
			userInput.caravanForm &&
			userInput.caravanForm.tellUsABitMore &&
			userInput.caravanForm.tellUsABitMore.promotionalCode
		) {
			transformedRequest.campaignCode =
				userInput.caravanForm.tellUsABitMore.promotionalCode;
		}

		return transformedRequest;
	}

	//dd-1040 - function to update hasCurrentInsurance field when yearContinuous Insurance > 0
	function updateCurrentInsurance(transformedRequest, userInput) {
		if (
			transformedRequest.caravans[0].drivers[0].driver &&
			transformedRequest.caravans[0].drivers[0].driverUsage == 'main'
		) {
			if (
				transformedRequest.caravans[0].drivers[0].driver
					.yearsContinuousInsurance != '0'
			) {
				var claims = Object.extend(transformedRequest.caravans[0], {
					yearsContinuousInsurance:
						transformedRequest.caravans[0].drivers[0].driver
							.yearsContinuousInsurance,
					timeSinceLastClaim:
						transformedRequest.caravans[0].drivers[0].driver
							.timeSinceLastClaim,
					hasCurrentInsurance: true
				});
			}
		}
		return transformedRequest;
	}

	function updateStampDutyEligibility(transformedRequest, userInput) {
		var stampDutyEligible = storage.getItem('stamp-duty');
		if (userInput.caravanForm.stampDutyExemption && stampDutyEligible) {
			transformedRequest.caravans[0].isSmallBusiness =
				userInput.caravanForm.stampDutyExemption.isSmallBusiness;
		} else {
			delete transformedRequest.caravans[0].isSmallBusiness;
		}
		return transformedRequest;
	}

	function updatePolicyAddress(transformedRequest, userInput) {
		var postalAddress = storage.getItem('policy-address');

		if (angular.isDefined(userInput.caravanForm.mainPolicyHolderContact)) {
			if (transformedRequest.postalAddress !== null) {
				transformedRequest.policyAddress =
					transformedRequest.postalAddress;
			} else {
				if (
					Object.keys(postalAddress).length > 0 &&
					!userInput.caravanForm.mainPolicyHolderContact.postalOption
				) {
					transformedRequest.policyAddress = postalAddress;
				}
			}
		} else {
			if (Object.keys(postalAddress).length > 0) {
				transformedRequest.policyAddress = postalAddress;
			}
		}
		delete transformedRequest.postalAddress;
		return transformedRequest;
	}

	function transform(userInput) {
		var transformedRequest = jsonMapper.transform(
			userInput,
			structureQuoteMapping
		);

		// Caravan
		transformedRequest = updateVehicleDetails(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleSubType(
			transformedRequest,
			userInput
		);
		transformedRequest = updateCaravanInfo(transformedRequest, userInput);
		transformedRequest = updateFinanceType(transformedRequest, userInput);
		transformedRequest = updateAgreedValue(transformedRequest, userInput);
		transformedRequest = updateAnnexeValue(transformedRequest, userInput);
		transformedRequest = updatePurchasePrice(transformedRequest, userInput);

		// Contents
		transformedRequest = updateContentsItems(transformedRequest, userInput);

		// Main driver/insured
		transformedRequest = updateStampDutyEligibility(
			transformedRequest,
			userInput
		);
		transformedRequest = updateDrivers(transformedRequest, userInput);

		// Contact
		transformedRequest = updatePolicyHolders(transformedRequest, userInput);

		// Quote
		transformedRequest = updateTotalCaravanValue(
			transformedRequest,
			userInput
		);
		transformedRequest = updateTotalSpecifiedContentsValue(
			transformedRequest,
			userInput
		);
		transformedRequest = updateTotalContentsSpecifiedValue(
			transformedRequest,
			userInput
		);
		transformedRequest = updateDiscountLayup(transformedRequest, userInput);
		transformedRequest = updateOnSiteDiscount(
			transformedRequest,
			userInput
		);
		transformedRequest = updateVehicleInsuranceOptionalBenefits(
			transformedRequest,
			userInput
		);
		transformedRequest = updateEmail(transformedRequest, userInput);
		transformedRequest = updateCurrentInsurance(
			transformedRequest,
			userInput
		);
		transformedRequest = updatePolicyAddress(transformedRequest, userInput);
		return transformedRequest;
	}

	function transposeMonth(monthName) {
		var months = {
			January: '01',
			February: '02',
			March: '03',
			April: '04',
			May: '05',
			June: '06',
			July: '07',
			August: '08',
			September: '09',
			October: '10',
			November: '11',
			December: '12'
		};

		return months[monthName];
	}

	return {
		transform: transform
	};
}
